import type { MockSectionCustomerInput } from './mockSectionData.util';
import { mockSectionData } from './mockSectionData.util';
import type { ReportSectionFieldSources } from './reportFieldSource.util';
import { isWarehouseWhoWereReachingSnapshot } from './whoWereReachingSnapshotDetect.util';

const WAREHOUSE_FIELD_SOURCES: ReportSectionFieldSources = {
  membersConnectedBh: 'warehouse',
  membersConnectedBhPct: 'warehouse',
  avgDaysToBhAppointment: 'warehouse',
  noPreEngBhVisit: 'warehouse',
  eligibleCostBhConnected: 'warehouse',
  eligibleCostBhPct: 'warehouse',
  eligibleCostBhReema: 'warehouse',
  bhCareTrend: 'warehouse',
  sankeyNodes: 'warehouse',
  insights: 'mock',
};

const MOCK_FIELD_SOURCES: ReportSectionFieldSources = {
  membersConnectedBh: 'mock',
  membersConnectedBhPct: 'mock',
  avgDaysToBhAppointment: 'mock',
  noPreEngBhVisit: 'mock',
  eligibleCostBhConnected: 'mock',
  eligibleCostBhPct: 'mock',
  eligibleCostBhReema: 'mock',
  bhCareTrend: 'mock',
  sankeyNodes: 'mock',
  insights: 'mock',
};

/**
 * Normalizes connections-behavioral-care snapshots with `fieldSources` for mock framing.
 * @param snapshot - Stored or live snapshot JSON.
 * @param customer - Customer context for mock fallback fields.
 * @param reportingPeriod - Report period label.
 * @returns Snapshot with `fieldSources` metadata for the Care Portal UI.
 */
export const normalizeConnectionsBehavioralCareSnapshot = (
  snapshot: Record<string, unknown>,
  customer: MockSectionCustomerInput,
  reportingPeriod: string,
): Record<string, unknown> => {
  const mockBase = mockSectionData(
    'connections-behavioral-care',
    customer,
    reportingPeriod,
  );
  const isWarehouse = isWarehouseWhoWereReachingSnapshot(snapshot);

  return {
    ...mockBase,
    ...snapshot,
    fieldSources: isWarehouse ? WAREHOUSE_FIELD_SOURCES : MOCK_FIELD_SOURCES,
    snapshotSource: isWarehouse ? snapshot.snapshotSource : undefined,
  };
};
